import React from 'react';
import { User } from 'lucide-react';

interface AvatarProps {
  url?: string | null;
  username?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-10 h-10 text-base',
  lg: 'w-12 h-12 text-lg'
};

export const Avatar: React.FC<AvatarProps> = ({ 
  url, 
  username = '', 
  size = 'md',
  className = ''
}) => {
  if (url) {
    return (
      <img
        src={url}
        alt={username}
        className={`rounded-full object-cover ${sizeClasses[size]} ${className}`}
      />
    );
  }

  const initial = username?.charAt(0).toUpperCase() || '?';
  const colors = [
    'bg-red-100 text-red-600',
    'bg-blue-100 text-blue-600',
    'bg-green-100 text-green-600',
    'bg-yellow-100 text-yellow-600',
    'bg-purple-100 text-purple-600',
  ];
  
  // Utiliser le code ASCII de la première lettre pour choisir une couleur
  const colorIndex = initial.charCodeAt(0) % colors.length;
  const color = colors[colorIndex];

  return (
    <div className={`rounded-full flex items-center justify-center font-medium ${color} ${sizeClasses[size]} ${className}`}>
      {initial}
    </div>
  );
}; 